import React from 'react';
type IconProps = {
  size?: number;
  className?: string;
};
/** Straight-blade hair clipper — modern line icon */
export function ClipperIcon({
  size = 28,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-14">
      {/* Blade teeth */}
      <path d="M4 4v3M7 4v3M10 4v3M13 4v3" data-id="element-15" />
      {/* Blade bar */}
      <path d="M3 7h11l2 2" data-id="element-16" />
      {/* Body */}
      <rect x="9" y="9" width="11" height="7" rx="2" transform="rotate(0 9 9)" data-id="element-17" />
      {/* Detail line + cord */}
      <path d="M12 12.5h5" data-id="element-18" />
      <path d="M20 16c1.5 1 2 2.5 1 4" data-id="element-19" />
    </svg>;
}
/** Straight razor — modern line icon */
export function RazorIcon({
  size = 28,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-20">
      {/* Blade */}
      <path d="M3 11 L14 4 c1-.6 2 .3 1.6 1.4 L12 14 Z" data-id="element-21" />
      {/* Pivot */}
      <circle cx="13.5" cy="13.5" r="1" data-id="element-22" />
      {/* Handle */}
      <path d="M13.8 14.2 L21 20 c.7.6-.1 1.7-.9 1.3 L13 17" data-id="element-23" />
    </svg>;
}
/** Scissors + comb — modern line icon for a classic cut */
export function CombScissorsIcon({
  size = 28,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-24">
      {/* Comb */}
      <path d="M3 8h13" data-id="element-25" />
      <path d="M5 8v3M8 8v3M11 8v3M14 8v3" data-id="element-26" />
      {/* Scissors */}
      <circle cx="18" cy="16" r="2" data-id="element-27" />
      <circle cx="18" cy="21" r="1.4" data-id="element-28" />
      <path d="M20 15 L9 20" data-id="element-29" />
      <path d="M20 18 L13 21" data-id="element-30" />
    </svg>;
}